import { useNavigate } from "react-router";
import { TitleImage, UserButton } from "./BaseComponents";

export default function Profile() {
  const navigate = useNavigate();
  const username = localStorage.getItem("username")

  const signOut = () => {
    localStorage.removeItem(username);
    localStorage.removeItem("username");
    navigate("/");
  };

  const projects = () => {
    navigate("/projects");
  };

  return (
    <div className="App-body">
      {TitleImage()}
      <div className="ContentBorder">
        <p className="Left-align">
          hi {username}, this site was the frontend for delete bot.
          delete bot allowed one to programmatically delete tweets.
          unfortunately twitter decided to make it hard for a bot to access their site without paying for the api, so the project has been deprecated.
          hopefully we will have something else interesting to host here in the future.
        </p>
        <br />
        <u><h3>other sites worth looking at</h3></u>
        <ul className="Left-align">
          <li>bay area shows: <a href="http://www.foopee.com/punk/the-list">http://www.foopee.com/punk/the-list</a></li>
          <li>infrequent hacking zine: <a href="https://phrack.org">https://phrack.org</a></li>
          <li>free research papers: <a href="https://sci-hub.box">https://sci-hub.box</a></li>
          <li>circumvent some paywalls: <a href="https://archive.is">https://archive.is</a></li>
          <li>self radicalize: <a href="https://theanarchistlibrary.org">https://theanarchistlibrary.org</a></li>
          <li>for those obscure tunes: <a href="https://www.metal-archives.com">https://www.metal-archives.com</a></li>
          <li>antidote to tech bros: <a href="https://youtube.com/@programmersarealsohuman5909">https://youtube.com/@programmersarealsohuman5909</a></li>
          <li>fun and games: <a href="https://rally-the-troops.com">https://rally-the-troops.com</a></li>
          <li>life sim: <a href="https://868-hack.neocities.org">https://868-hack.neocities.org</a></li>
        </ul>
        <br />
        <u><h3>previously featured records</h3></u>
        <ul className="Left-align">
          <li><a href="https://nedgravd.bandcamp.com/album/ascension">ascension - nedgravd</a></li>
        </ul>
        <br />
        <u><h3>contact swampyankeetech</h3></u>
        <ol className="List-gap">
          <li>write a message on a piece of paper or parchment clearly addressed to swampyankeetech.com</li>
          <li>find a large candle worth of wax.</li>
          <li>find a clear empty bottle with a narrow neck; an old crow bottle is ideal.</li>
          <li>put the paper or parchment in the bottle.</li>
          <li>melt the wax in a convenient container.</li>
          <li>cork the bottle with whatever is at hand, the original cap, a rag, what have you.</li>
          <li>dip the neck of the bottle into the melted wax repeatedly until satisfied with wax accumulation.</li>
          <li>toss bottle into the nearest sea or ocean.</li>
          <li>hope that if and when someone finds the message they can read whatever language you wrote it in,
            swampyankeetech.com still exists, and swampyankeetech.com has added an email contact.</li>
        </ol>
      </div>
      <div className="User-2H-button-div">
        <div className="User-button-div-left">
          <UserButton button_name="projects" do_something={projects} />
        </div>
        <div className="User-button-div-right">
          <UserButton button_name="sign out" do_something={signOut} />
        </div>
      </div>
    </div>
  );
}
